import { FunctionComponent, PropsWithChildren, useContext } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { ThemeProvider, useTheme } from "@mui/material/styles";

import { FrontendFormContext } from "../../../common/contexts/FrontendFormContext";
import { zeffyTheme } from "../../../common/theme/theme";

import { InfoFormProps } from "./types";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { getTransitions } from "@/dashboard-design-system/css";
import { DashboardTooltip } from "@/dashboard-design-system/DashboardTooltip/DashboardTooltip";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { ArrowRight as RightArrowIcon } from "@/icons/outlined";

export const InfoForm = ({ content }: InfoFormProps) => {
  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        borderRadius: theme.spacing(1),
        backgroundColor: zeffyTheme.palette.surface.brand.intense,
        ...getTransitions("opacity 100ms ease-out", "opacity"),
      }}
    >
      <Grid item xs={1} paddingBottom={0.5} paddingTop={0.5} marginRight={1.25}>
        <Box
          sx={{
            fill: theme.palette.text.reverse.intense,
          }}
        >
          <RightArrowIcon />
        </Box>
      </Grid>
      <Grid item xs>
        <DashboardTypography vibe="text-reverse-intense" variant="subtitle2">
          {content}
        </DashboardTypography>
      </Grid>
    </Grid>
  );
};

export const DisplayWithInfoFormPreview: FunctionComponent<PropsWithChildren<InfoFormProps>> = ({
  content,
  children,
}) => {
  const theme = useTheme();
  const { isSmallScreen } = useMediaQuery();
  const { isPreviewTemplateMode } = useContext(FrontendFormContext);

  return (
    <ThemeProvider theme={zeffyTheme}>
      <DashboardTooltip
        vibe="brand"
        title={!isPreviewTemplateMode || isSmallScreen ? null : <InfoForm content={content} />}
        placement="right"
      >
        <Grid container>
          <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </Grid>
      </DashboardTooltip>
    </ThemeProvider>
  );
};
